/*=========================================================================================
  File Name: moduleAuthActions.js
  Description: Auth Module Actions
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
==========================================================================================*/

import router from "@/router"

import axiosInstance from "../../libs/axios"


export default {

    login({commit}, payload) {
        return new Promise((resolve, reject) => {
            axiosInstance.post("/accounts/login", payload).then((res) => {
                const response = res.data
                localStorage.setItem("token", JSON.stringify(response.tokenResponse.token).replace(/['"]+/g, ""));
                localStorage.setItem("refreshToken", JSON.stringify(response.tokenResponse.refreshToken).replace(/['"]+/g, ""));
                commit("SET_BEARER", JSON.stringify(response.tokenResponse.token).replace(/['"]+/g, ""));
                // commit('SET_USER', user);
                resolve(response)
            })
                .catch((error) => {
                    reject(error)
                })
        })
    },

    refreshToken({commit}, payload) {
        return new Promise((resolve, reject) => {
            axiosInstance.post("/accounts/refresh_token", payload).then((res) => {
                const response = res.data
                localStorage.setItem("token", JSON.stringify(response.tokenResponse.token).replace(/['"]+/g, ""));
                localStorage.setItem("refreshToken", JSON.stringify(response.tokenResponse.refreshToken).replace(/['"]+/g, ""));
                commit("SET_BEARER", JSON.stringify(response.tokenResponse.token).replace(/['"]+/g, ""));
                // commit('SET_USER', user);
                resolve(response)
            })
                .catch((error) => {
                    reject(error)
                })
        })
    },

}
